import { FormattedMessage } from 'react-intl';
import { CaseClosingConfigurationDto } from 'types/caseClosing';
import { AutomaticClosingSubsection } from './AutomaticClosingSubsection';
import { ClosingConditionsSubsection } from './ClosingConditionsSubsection';
import { ClosingOnInvoiceSendSubsection } from './ClosingOnInvoiceSendSubsection';
import { ConfidentialCasesSubsection } from './ConfidentialCasesSubsection';

interface Props {
    caseClosing: CaseClosingConfigurationDto;
}

export function CaseClosingConfig({ caseClosing }: Props) {
    return (
        <div className="flex flex-col gap-4">
            <h3 className="text-h3 text-balance">
                <FormattedMessage id="case-closing-config.case-closing" />
            </h3>
            <ClosingConditionsSubsection caseClosing={caseClosing} />
            <AutomaticClosingSubsection caseClosing={caseClosing} />
            <ClosingOnInvoiceSendSubsection caseClosing={caseClosing} />
            <ConfidentialCasesSubsection caseClosing={caseClosing} />
        </div>
    );
}
